module.exports = __webpack_public_path__ + "img/sign-46.59d91aad.jpg";